<!-- <ngx-ui-loader fgsColor="#ff4081" text="please wait" pgColor="#ff4081"></ngx-ui-loader> -->

<router-outlet></router-outlet>

